module.exports = __webpack_public_path__ + "img/2026-chicago-qr.d8bbf826.jpg";